// extracted by mini-css-extract-plugin
export default {"label":"FieldInternationalPhoneNumber_label__upO4W"};